var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Date_Range_ic",
    "data-name": "Date Range_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14043",
    "data-name": "Rectangle 14043",
    width: 13,
    height: 13,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(1 1.554)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Path_58056",
    "data-name": "Path 58056",
    d: "M8.913,3.484A1.484,1.484,0,1,1,10.4,4.967,1.484,1.484,0,0,1,8.913,3.484Zm-7.418.495H7.429a.495.495,0,1,0,0-.989H1.495a.495.495,0,0,0,0,.989ZM4.462,5.462a1.484,1.484,0,0,0-1.395.989H1.495a.495.495,0,0,0,0,.989H3.067A1.484,1.484,0,1,0,4.462,5.462Zm6.924.989H7.429a.495.495,0,0,0,0,.989h3.956a.495.495,0,1,0,0-.989ZM5.451,9.913H1.495a.495.495,0,1,0,0,.989H5.451a.495.495,0,1,0,0-.989Zm5.935,0H9.813a1.484,1.484,0,1,0,0,.989h1.573a.495.495,0,1,0,0-.989Z",
    transform: "translate(-1 -2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreFilter);
export default __webpack_public_path__ + "static/media/more_filter.f0ccf426.svg";
export { ForwardRef as ReactComponent };